import { Injectable, inject } from '@angular/core';
import { EnvToken } from '@app/core/env.tokens';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { City } from '@models/Location/city.model';
import { Region } from '@models/Location/region.model';
@Injectable({
  providedIn: 'root',
})
export class RegionService {
  protected readonly env = inject(EnvToken);

  baseHref = `${this.env.dashboardBaseRef}api/${this.env.apiPrefix}location`;

  constructor(private http: HttpClient) {}

  findByRegionURL(regionURL: string): Observable<Region> {
    const url = `${this.baseHref}/${regionURL}`;
    return this.http.get<any>(url);
  }

  findAll(): Observable<Region[]> {
    const url = `${this.baseHref}/regions`;
    return this.http.get<Region[]>(url);
  }

  findRelatedCities(regionURL: string): Observable<City[]> {
    const url = `${this.baseHref}/related-cities/${regionURL}`;
    return this.http.get<City[]>(url);
  }
}
